import { render, staticRenderFns } from "./WspButton.vue?vue&type=template&id=34da059c&scoped=true&"
import script from "./WspButton.vue?vue&type=script&lang=js&"
export * from "./WspButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34da059c",
  null
  
)

export default component.exports